// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__2hemT","input":"Form_input__Vfo9P","btn":"Form_btn__2RK0U","feedbackBtnArea":"Form_feedbackBtnArea__2O1fU","feedback":"Form_feedback__2y7DP"};